import { isNil } from 'lodash';

export function isNoCodeCard(card: MBAPI.Card): boolean {
  return isNil(card.cardDefinitionId) && !isNil(card.workflowTemplateId);
}
